import styled from "styled-components";

export const ReportIssuePage = styled.iframe.attrs({
  src:
    "https://www.sekuritance.com/forms/report-an-issue/",
})`
  border: none;
  width: 100%;
  height: 100%;
`;
